/**
 * cart-extras.js
 * Vervangt de drie SlideCart HQ functies die daadwerkelijk in gebruik waren.
 * Geen externe bibliotheken. Leunt op Impulse's eigen cart:updated / cart:build events.
 *
 * Toegevoegd 1 aug 2026
 */
(function () {
  'use strict';

  var ROUTES = (window.theme && theme.routes) || {};
  var CART_JS = (ROUTES.cart) || '/cart.js';
  var CART_ADD = (ROUTES.cartAdd) || '/cart/add.js';
  var CART_CHANGE = (ROUTES.cartChange) || '/cart/change.js';

  /*
    De busy-vlag voorkomt twee gelijktijdige schrijfacties naar de winkelwagen.
    Blijft een verzoek hangen, dan zou de vlag voor altijd aan staan en werkt de
    toggle niet meer. Daarom altijd na 8 seconden vrijgeven.
  */
  var busy = false;
  var busyTimer = null;
  function zetBusy(waarde) {
    busy = waarde;
    if (busyTimer) { clearTimeout(busyTimer); busyTimer = null; }
    if (waarde) busyTimer = setTimeout(function () { busy = false; }, 8000);
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getCart() {
    return fetch(CART_JS, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ----------------------------------------------------------------------
     1. Rewards-voortgangsbalk
     ---------------------------------------------------------------------- */
  function renderRewards(cart) {
    var bars = document.querySelectorAll('[data-cart-rewards]');
    if (!bars.length) return;

    Array.prototype.forEach.call(bars, function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10) || 0;
      var exclude = parseInt(bar.dataset.excludeVariant, 10);

      // Bepaal het bedrag dat meetelt voor de drempel
      var total = cart.total_price;
      if (exclude) {
        cart.items.forEach(function (item) {
          if (item.variant_id === exclude) {
            total -= item.final_line_price;
          }
        });
      }
      if (total < 0) total = 0;

      // Lege cart: balk verbergen
      if (!cart.item_count) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;

      var remaining = threshold - total;
      var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;

      var textEl = bar.querySelector('[data-cart-rewards-text]');
      var fillEl = bar.querySelector('[data-cart-rewards-fill]');

      if (remaining > 0) {
        bar.classList.remove('is-unlocked');
        if (textEl) {
          textEl.innerHTML = bar.dataset.preText.replace('{{ amount }}', '<strong>' + money(remaining) + '</strong>') +
            ' <strong>' + bar.dataset.label + '</strong>';
        }
      } else {
        bar.classList.add('is-unlocked');
        if (textEl) {
          textEl.innerHTML = '<strong>' + bar.dataset.label + '</strong> ' + bar.dataset.postText;
        }
      }
      if (fillEl) fillEl.style.width = pct + '%';
    });
  }

  /* ----------------------------------------------------------------------
     2. "Your cart is reserved for [countdown]"
     ---------------------------------------------------------------------- */
  var timerInterval = null;

  function reservedKey() { return 'cartReservedUntil'; }

  function startReservation(cart) {
    var els = document.querySelectorAll('[data-cart-reserved]');
    if (!els.length) return;

    // Geen items? Timer verbergen en resetten.
    if (!cart || !cart.item_count) {
      Array.prototype.forEach.call(els, function (el) { el.hidden = true; });
      try { sessionStorage.removeItem(reservedKey()); } catch (e) {}
      if (timerInterval) { clearInterval(timerInterval); timerInterval = null; }
      return;
    }

    var minutes = parseInt(els[0].dataset.minutes, 10) || 10;
    var until;
    try { until = parseInt(sessionStorage.getItem(reservedKey()), 10); } catch (e) {}

    if (!until || isNaN(until) || until < Date.now()) {
      until = Date.now() + minutes * 60 * 1000;
      try { sessionStorage.setItem(reservedKey(), String(until)); } catch (e) {}
    }

    function tick() {
      var left = until - Date.now();
      if (left <= 0) {
        Array.prototype.forEach.call(els, function (el) { el.hidden = true; });
        clearInterval(timerInterval);
        timerInterval = null;
        return;
      }
      var m = Math.floor(left / 60000);
      var s = Math.floor((left % 60000) / 1000);
      var label = m + ':' + (s < 10 ? '0' : '') + s;
      Array.prototype.forEach.call(els, function (el) {
        el.hidden = false;
        var t = el.querySelector('[data-cart-reserved-time]');
        if (t) t.textContent = label;
      });
    }

    tick();
    if (timerInterval) clearInterval(timerInterval);
    timerInterval = setInterval(tick, 1000);
  }

  /* ----------------------------------------------------------------------
     3. Insured Delivery-toggle
     ---------------------------------------------------------------------- */
  function findInsuranceLine(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) {
        return { item: cart.items[i], line: i + 1, key: cart.items[i].key };
      }
    }
    return null;
  }

  function renderInsurance(cart) {
    var blocks = document.querySelectorAll('[data-cart-insurance]');
    if (!blocks.length) return;

    Array.prototype.forEach.call(blocks, function (block) {
      var variantId = parseInt(block.dataset.variantId, 10);
      var found = findInsuranceLine(cart, variantId);

      // Alleen tonen als er iets anders dan de verzekering in de cart zit
      var otherItems = cart.items.filter(function (i) { return i.variant_id !== variantId; }).length;
      block.hidden = otherItems === 0;

      var input = block.querySelector('[data-cart-insurance-toggle]');
      if (input) input.checked = !!found;

      /*
        Bewust GEEN automatische verwijdering meer. Die schreef naar de cart
        tijdens het opnieuw tekenen, en botste dan met de aantalknoppen van het
        theme die op datzelfde moment /cart/change.js aanroepen. Twee gelijktijdige
        wijzigingen laten de winkelwagen vastlopen. We verbergen de toggle nu
        alleen; de klant haalt de verzekering zelf weg als hij dat wil.
      */
    });
  }

  /* Een regelsleutel blijft geldig als er elders iets verandert; een volgnummer niet. */
  function updateLine(sleutel, quantity) {
    if (busy) return Promise.resolve();
    zetBusy(true);
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: sleutel, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { zetBusy(false); afterCartChange(cart); return cart; })
      .catch(function (e) { zetBusy(false); console.error('[cart-extras]', e); });
  }

  function addVariant(variantId) {
    if (busy) return Promise.resolve();
    zetBusy(true);
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function () { return getCart(); })
      .then(function (cart) { zetBusy(false); afterCartChange(cart); return cart; })
      .catch(function (e) { zetBusy(false); console.error('[cart-extras]', e); });
  }

  function onInsuranceToggle(e) {
    var input = e.target.closest('[data-cart-insurance-toggle]');
    if (!input) return;
    var block = input.closest('[data-cart-insurance]');
    if (!block) return;

    var variantId = parseInt(block.dataset.variantId, 10);
    input.disabled = true;

    getCart().then(function (cart) {
      var found = findInsuranceLine(cart, variantId);
      var done;
      if (input.checked && !found) {
        done = addVariant(variantId);
      } else if (!input.checked && found) {
        done = updateLine(found.key, 0);
      } else {
        done = Promise.resolve();
      }
      return done;
    }).then(function () {
      input.disabled = false;
    });
  }

  /* ----------------------------------------------------------------------
     4. Veiligheidsnet voor de aantalknoppen in de winkelwagen
     ----------------------------------------------------------------------
     Het theme zet .is-loading op .js-qty__wrapper zodra je op + of - klikt.
     Die klasse zet opacity op 0,5 en pointer-events op none - het grijze,
     onaanklikbare vakje. Hij wordt op precies één manier weer weggehaald:
     doordat het theme de winkelwagen opnieuw opbouwt en de knoppen vervangt.

     Gaat dat verzoek mis, dan gebeurt dat nooit. In theme.js staat namelijk:

         .catch(function(XMLHttpRequest){});

     Een lege catch. Er wordt niets hersteld, niets gemeld, en het vakje
     blijft grijs tot je de pagina ververst.

     Misgaan kan op twee manieren die op deze winkel allebei echt voorkomen:

       - Shopify klapt bij snel achter elkaar klikken even dicht en stuurt
         geen JSON terug. Dan struikelt response.json() en belandt alles in
         die lege catch.

       - De regelsleutel is veranderd. Door je staffelkortingen (15% vanaf 2,
         20% vanaf 3, 25% vanaf 4) krijgt een regel bij elk nieuw aantal een
         andere sleutel. Live nagemeten: bij drie wijzigingen achter elkaar
         kreeg dezelfde regel drie verschillende sleutels. Klikt iemand nog
         voordat de winkelwagen opnieuw is opgebouwd, dan gaat het verzoek
         met de oude sleutel weg en antwoordt Shopify met
         "no valid id or line parameter".

     Hieronder houden we die vergrendeling in de gaten. Blijft hij langer dan
     een paar seconden staan, dan halen we hem weg en laten we de winkelwagen
     opnieuw opbouwen, zodat het getoonde aantal ook weer klopt.
     ---------------------------------------------------------------------- */
  /*
    Zes seconden bleek in de praktijk veel te lang: een klant ziet dan zes
    tellen een grijs vakje dat nergens op reageert en denkt dat de winkel
    stuk is. Een normale wijziging is binnen een seconde rond, dus 2,5 s is
    ruim genoeg om een traag maar geslaagd verzoek niet in de rede te vallen.
  */
  var QTY_VAST_MS = 2500;

  function ontgrendelQty() {
    var vast = document.querySelectorAll('.js-qty__wrapper.is-loading');
    if (!vast.length) return false;
    Array.prototype.forEach.call(vast, function (el) {
      el.classList.remove('is-loading');
    });
    return true;
  }

  function bewaakQtyKnoppen() {
    if (typeof MutationObserver === 'undefined') return;
    var timers = new WeakMap();

    new MutationObserver(function (mutaties) {
      mutaties.forEach(function (m) {
        var el = m.target;
        if (!el.classList || !el.classList.contains('js-qty__wrapper')) return;

        if (el.classList.contains('is-loading')) {
          if (timers.get(el)) return;
          timers.set(el, setTimeout(function () {
            timers.delete(el);
            // Is het element intussen vervangen, dan is alles goed gegaan.
            if (!document.body.contains(el)) return;
            if (!el.classList.contains('is-loading')) return;
            el.classList.remove('is-loading');
            console.warn('[cart-extras] aantalknoppen zaten vast, hersteld');
            document.dispatchEvent(new CustomEvent('cart:build'));
          }, QTY_VAST_MS));
        } else {
          var t = timers.get(el);
          if (t) { clearTimeout(t); timers.delete(el); }
        }
      });
    }).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    /*
      Stuurt Shopify een foutobject in plaats van een winkelwagen, dan hoeven
      we die zes seconden niet af te wachten - dan weten we het meteen.
    */
    document.addEventListener('cart:updated', function (evt) {
      var c = evt.detail && evt.detail.cart;
      if (c && typeof c.item_count === 'undefined') {
        if (ontgrendelQty()) {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
      }
    });
  }

  /* ----------------------------------------------------------------------
     5. Aantal op 0 zetten moet het product ook echt verwijderen
     ----------------------------------------------------------------------
     In theme.js staat:

         quantityChanged: function(evt) {
           var key = evt.detail[0];
           var qty = evt.detail[1];
           ...
           if (!key || !qty) { return; }

     Bij aantal 0 is !qty waar, dus die functie stapt er meteen uit. Het
     invoervakje toont dan 0 - dat zet QtySelector zelf al - maar er gaat
     nooit een verzoek naar Shopify. Het product blijft gewoon in de
     winkelwagen staan, met korting en al, terwijl er 0 in beeld staat.

     Dat is precies wat een klant doet die iets wil weghalen: net zo lang op
     de min drukken tot hij op nul staat. Het theme heeft wel een aparte
     verwijderknop, maar wie de min gebruikt komt vast te zitten.

     Hieronder vangen we dat geval op. Het theme luistert naar hetzelfde
     event en doet niets, dus we komen elkaar niet in de weg.
     ---------------------------------------------------------------------- */
  function verwijderRegel(key, el) {
    if (el) el.classList.add('is-loading');
    return fetch(CART_CHANGE, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count === 'undefined') {
          throw new Error(cart && cart.description ? cart.description : 'verwijderen mislukt');
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function (e) {
        console.error('[cart-extras] verwijderen mislukt', e);
        ontgrendelQty();
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
  }

  /*
    vangNulAantalOp is per 2 aug 2026 vervallen. We nemen de knoppen nu zelf
    over (zie hierboven) en sturen aantal 0 gewoon mee, dus die aparte
    omweg via het cart:quantity-event is niet meer nodig.
  */


  /* ----------------------------------------------------------------------
     6. Hertekenen afdwingen na het opnieuw opbouwen
     ----------------------------------------------------------------------
     Op iOS komt het voor dat de + of - even niet getekend wordt nadat het
     theme de winkelwagen opnieuw heeft opgebouwd. De knop is er wel, hij is
     alleen niet zichtbaar tot je scrolt of ergens tikt. Een klein duwtje op
     de compositielaag laat de browser opnieuw tekenen; onzichtbaar voor de
     bezoeker, want we zetten het in hetzelfde beeldje weer terug.
     ---------------------------------------------------------------------- */
  /* Niet elke omgeving kent requestAnimationFrame; dan pakken we een timer. */
  var volgendBeeldje = (typeof window !== 'undefined' && window.requestAnimationFrame)
    ? window.requestAnimationFrame.bind(window)
    : function (cb) { return setTimeout(cb, 16); };

  function duwHertekening() {
    var vakjes = document.querySelectorAll('.js-qty__wrapper');
    if (!vakjes.length) return;
    Array.prototype.forEach.call(vakjes, function (el) {
      el.style.transform = 'translateZ(0)';
    });
    volgendBeeldje(function () {
      Array.prototype.forEach.call(vakjes, function (el) {
        el.style.transform = '';
      });
    });
  }

  /* ----------------------------------------------------------------------
     7. Kliks op + en - samenvoegen tot één verzoek
     ----------------------------------------------------------------------
     DIT IS DE KERN VAN HET PROBLEEM MET DE AANTALLEN.

     Het theme stuurt per klik een POST naar /cart/change.js. Tik je vijf keer
     achter elkaar, dan gaan er vijf verzoeken weg. Shopify ziet dat als
     verdacht verkeer en antwoordt op een gegeven moment met:

         HTTP 429, content-type text/html, titel "Verifying your connection..."

     Dat is geen JSON, dus response.json() struikelt, en in theme.js staat als
     enige opvang `.catch(function(XMLHttpRequest){})` - een lege catch. Er
     wordt niets hersteld en niets gemeld.

     Ondertussen heeft QtySelector het getal in beeld al opgehoogd, want dat
     doet hij lokaal vóórdat het verzoek weggaat. Resultaat: 9 in beeld,
     4 op de server, een subtotaal dat er niet bij past, en een klant die na
     verversen ineens iets heel anders in zijn winkelwagen ziet staan.

     Hieronder nemen we de knoppen over. Klikken worden opgeteld in het
     scherm - de bezoeker ziet direct wat hij doet - en pas na een halve
     seconde stilte gaat er ÉÉN verzoek weg met het eindaantal. Vijf tikken
     is dus één verzoek in plaats van vijf.

     Vlak voor verzending halen we de actuele regelsleutel op. Die verandert
     namelijk bij elke wijziging doordat je staffelkorting meeschuift, en met
     een verouderde sleutel antwoordt Shopify met "no valid id or line
     parameter".

     Gaat er alsnog iets mis, dan zetten we het getal terug op wat de server
     zegt. Het scherm liegt dan nooit.
     ---------------------------------------------------------------------- */
  var QTY_WACHT_MS = 500;
  var qtyTimers = new WeakMap();
  var qtyDoelen = new WeakMap();

  function variantUitSleutel(sleutel) {
    return String(sleutel || '').split(':')[0];
  }

  function huidigeRegel(cart, sleutel) {
    var i;
    for (i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === sleutel) return cart.items[i];
    }
    // Sleutel verouderd: terugvallen op het variantnummer, dat blijft gelijk.
    var variant = variantUitSleutel(sleutel);
    for (i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === variant) return cart.items[i];
    }
    return null;
  }

  function zetTerugOpServerwaarde(input, sleutel) {
    return getCart().then(function (cart) {
      var regel = huidigeRegel(cart, sleutel);
      if (input && document.body.contains(input)) {
        input.value = regel ? regel.quantity : 0;
      }
      return cart;
    })['catch'](function () {});
  }

  function verstuurAantal(input, wrapper, sleutel) {
    var doel = qtyDoelen.get(input);
    qtyDoelen['delete'](input);
    if (typeof doel !== 'number') return;

    if (wrapper) wrapper.classList.add('is-loading');

    // Actuele sleutel ophalen: de oude kan door de korting verlopen zijn.
    getCart()
      .then(function (cart) {
        var regel = huidigeRegel(cart, sleutel);
        if (!regel) throw new Error('regel niet meer gevonden');
        if (regel.quantity === doel) return null; // niets te doen

        return fetch(CART_CHANGE, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: regel.key, quantity: doel })
        }).then(function (r) {
          if (r.status === 429) throw new Error('te veel verzoeken achter elkaar');
          return r.text().then(function (tekst) {
            try { return JSON.parse(tekst); }
            catch (e) { throw new Error('geen geldig antwoord van de winkelwagen'); }
          });
        });
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'undefined') {
          throw new Error(cart.description || cart.message || 'wijziging geweigerd');
        }
        if (wrapper) wrapper.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        } else {
          refresh();
        }
      })
      ['catch'](function (e) {
        console.warn('[cart-extras] aantal bijwerken mislukt:', e && e.message);
        if (wrapper) wrapper.classList.remove('is-loading');
        // Nooit een verkeerd getal laten staan.
        zetTerugOpServerwaarde(input, sleutel).then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
      });
  }

  /*
    Het samenvoegen introduceert een halve seconde waarin een wijziging nog
    niet verstuurd is. Klikt iemand in dat halve seconde op afrekenen, dan zou
    hij met een verouderde winkelwagen naar de kassa gaan. Daarom sturen we
    alles wat nog openstaat eerst weg, en pas daarna gaan we door.
  */
  function openstaandeWijzigingen() {
    var wachtenden = [];
    var inputs = document.querySelectorAll('.js-qty__num[data-id]');
    Array.prototype.forEach.call(inputs, function (input) {
      if (qtyTimers.get(input)) wachtenden.push(input);
    });
    return wachtenden;
  }

  function spoelDoor() {
    var wachtenden = openstaandeWijzigingen();
    wachtenden.forEach(function (input) {
      var t = qtyTimers.get(input);
      if (t) clearTimeout(t);
      qtyTimers['delete'](input);
      var wrapper = input.closest('.js-qty__wrapper');
      verstuurAantal(input, wrapper, input.getAttribute('data-id'));
    });
    return wachtenden.length;
  }

  function bewaakAfrekenen() {
    document.addEventListener('click', function (e) {
      var knop = e.target && e.target.closest &&
        e.target.closest('[name="checkout"], .cart__checkout, a[href*="/checkout"]');
      if (!knop) return;
      if (!openstaandeWijzigingen().length) return;

      e.preventDefault();
      e.stopPropagation();
      spoelDoor();

      /*
        Even wachten tot de winkelwagen bijgewerkt is en dan alsnog doorgaan.
        Bewust kort: liever een halve seconde wachten dan met een verkeerd
        aantal afrekenen.
      */
      setTimeout(function () {
        if (knop.tagName === 'A' && knop.href) {
          window.location.href = knop.href;
        } else if (knop.form) {
          knop.form.submit();
        } else {
          knop.click();
        }
      }, 600);
    }, true);

    // Verlaat iemand de pagina, dan sturen we het laatste nog snel weg.
    window.addEventListener('pagehide', function () {
      openstaandeWijzigingen().forEach(function (input) {
        var doel = qtyDoelen.get(input);
        var sleutel = input.getAttribute('data-id');
        if (typeof doel !== 'number' || !sleutel) return;
        try {
          fetch(CART_CHANGE, {
            method: 'POST',
            credentials: 'same-origin',
            keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: sleutel, quantity: doel })
          });
        } catch (err) {}
      });
    });
  }

  function neemQtyKnoppenOver() {
    document.addEventListener('click', function (e) {
      var knop = e.target && e.target.closest && e.target.closest('.js-qty__adjust');
      if (!knop) return;

      var wrapper = knop.closest('.js-qty__wrapper');
      if (!wrapper) return;

      var input = wrapper.querySelector('.js-qty__num');
      if (!input) return;

      var sleutel = input.getAttribute('data-id');
      // Zonder regelsleutel is dit geen winkelwagen maar een productformulier;
      // daar mag het theme gewoon zijn gang gaan.
      if (!sleutel) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      var minimum = parseInt(input.getAttribute('min'), 10);
      if (isNaN(minimum)) minimum = 0;

      var huidig = qtyDoelen.get(input);
      if (typeof huidig !== 'number') huidig = parseInt(input.value, 10) || 0;

      var nieuw = knop.classList.contains('js-qty__adjust--plus') ? huidig + 1 : huidig - 1;
      if (nieuw < minimum) nieuw = minimum;

      qtyDoelen.set(input, nieuw);
      input.value = nieuw; // meteen zichtbaar, ook al gaat het verzoek later weg

      var t = qtyTimers.get(input);
      if (t) clearTimeout(t);
      qtyTimers.set(input, setTimeout(function () {
        qtyTimers['delete'](input);
        verstuurAantal(input, wrapper, sleutel);
      }, QTY_WACHT_MS));
    }, true);
  }

  /* ----------------------------------------------------------------------
     Gedeeld
     ---------------------------------------------------------------------- */
  function afterCartChange(cart) {
    // Directe feedback in onze eigen elementen...
    render(cart);
    // ...en laat Impulse de drawer/cartpagina opnieuw opbouwen.
    // Impulse vuurt daarna zelf cart:updated af, dus die dispatchen we hier
    // bewust NIET - anders draait render twee keer per wijziging.
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function render(cart) {
    if (!cart || !cart.items) return;
    renderRewards(cart);
    renderInsurance(cart);
    startReservation(cart);
    duwHertekening();
  }

  function refresh() {
    getCart().then(render);
  }

  /*
    Init mag maar één keer draaien. Zonder deze vergrendeling registreren we
    onze luisteraars dubbel als het script twee keer wordt ingeladen of als
    DOMContentLoaded nog een keer langskomt - en dan sturen we ook twee
    verzoeken naar de winkelwagen voor één klik.
  */
  var geinitialiseerd = false;

  function init() {
    if (geinitialiseerd) return;
    geinitialiseerd = true;

    neemQtyKnoppenOver();
    bewaakAfrekenen();
    bewaakQtyKnoppen();
    document.addEventListener('change', onInsuranceToggle);

    // Impulse laat weten dat de cart is bijgewerkt
    document.addEventListener('cart:updated', function (evt) {
      if (evt.detail && evt.detail.cart) {
        render(evt.detail.cart);
      } else {
        refresh();
      }
    });
    document.addEventListener('ajaxProduct:added', refresh);
    document.addEventListener('drawerOpen', refresh);

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
